module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-help-link-3680ed2f11307b950e9c57ef47e88a56.png";